import { Reveal } from "@/components/Reveal";

export default function PageHeader({ label, title, sub, image }) {
  return (
    <section className="relative overflow-hidden grain border-b border-white/5">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_20%,rgba(16,185,129,0.14),transparent_45%)]" />
      {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-20" />}
      <div className="absolute inset-0 bg-gradient-to-t from-[#060B11] via-[#060B11]/70 to-transparent" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <Reveal>
          {label && <div className="mono-label mb-4">{label}</div>}
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.08] max-w-4xl">{title}</h1>
          {sub && <p className="text-slate-300 mt-5 max-w-2xl text-base sm:text-lg leading-relaxed">{sub}</p>}
        </Reveal>
      </div>
    </section>
  );
}
